import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { OnboardingChecklist } from './OnboardingTutorial';
import { LegacyJourney } from './LegacyJourney';

export function GlobalHelpButton() {
  const { user } = useAuth();
  const [showChecklist, setShowChecklist] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showJourney, setShowJourney] = useState(false);

  // Listen for events from Header's help menu
  useEffect(() => {
    const handleHelpAction = (e) => {
      const { action } = e.detail;
      if (action === 'journey') {
        setShowJourney(true);
        setShowMenu(false);
      } else if (action === 'checklist') {
        setShowChecklist(true);
        setShowMenu(false);
      }
    };

    window.addEventListener('openHelpAction', handleHelpAction);
    return () => window.removeEventListener('openHelpAction', handleHelpAction);
  }, []);

  // Only show for logged-in users
  if (!user) return null;

  return (
    <>
      {/* Checklist Modal with backdrop */}
      {showChecklist && (
        <>
          {/* Backdrop overlay - click to close */}
          <div 
            className="fixed inset-0 bg-black/40 z-40"
            onClick={() => setShowChecklist(false)}
            data-testid="checklist-backdrop"
          />
          {/* Checklist - centered on mobile, positioned on desktop */}
          <div className="fixed z-50 
            inset-4 sm:inset-auto 
            sm:bottom-28 sm:left-6 
            flex items-center justify-center sm:block
            max-h-[85vh] sm:max-h-[70vh]"
          >
            <div className="w-full max-w-md max-h-full overflow-y-auto">
              <OnboardingChecklist onClose={() => setShowChecklist(false)} />
            </div>
          </div>
        </>
      )}

      {/* Legacy Journey */}
      <LegacyJourney 
        isOpen={showJourney} 
        onClose={() => setShowJourney(false)}
      />
    </>
  );
}
